type CustomerServiceUser = {
  name?: string;
  email?: string;
  user_id?: string;
  company?: string;
};

export const setCustomerServiceUser = (
  currentUser: CustomerServiceUser,
): void => {
  if (currentUser) {
    const win = window as any;
    const { name, email, company, user_id } = currentUser;
    const current = win.intercomSettings ?? {};
    win.intercomSettings = {
      ...current,
      name,
      email,
      company,
      user_id,
    };
  }
};
